import React from 'react';
import { Form, SubmitButton } from '../form';
import { ILoginFormProps } from './types';
import { useAuthentication } from '../authentiction';

const LoginForm: React.FC<ILoginFormProps> = ({
  redirectPath,
  children,
  ...rest
}) => {
  const { onLogin } = useAuthentication();

  return (
    <Form
      onSubmit={(response) => onLogin(response.data, redirectPath)}
      onError={(error, formikHelpers) => {
        formikHelpers.resetForm();
      }}
      {...rest}
    >
      <div>{children}</div>
      <SubmitButton>Login</SubmitButton>
    </Form>
  );
};

export default LoginForm;
